// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';
import Swiper, {
  Autoplay,
  Pagination as SwiperPagination,
  Navigation,
} from 'swiper';

Swiper.use([Autoplay, SwiperPagination, Navigation]);


class Pagination {
  static init() {
    const pagination = new Pagination();
    pagination.executeOnTheBrightSide();
  }

  constructor() {
    this.itemContainer = document.querySelector('.pagination-item-container');
    this.prev = document.querySelector('.pagination .page-control-prev');
    this.next = document.querySelector('.pagination .page-control-next');
    this.pagination = document.querySelector('.pagination');
    this.filterElements = document.querySelectorAll('.pagination-filter');
    this.formElement = document.querySelector('.pagination-form');
    this.applyFiltersButtons = document.querySelectorAll('.pagination-apply-filter-button');
    this.noResultsContainer = document.querySelector('.pagination-no-results-container');
    this.itemContainerDefaultDisplay = 'block';
    this.noResultsContainerDefaultDisplay = 'block';
    this.paginationDefaultDisplay = 'flex';

    this.initPageItemsAndLinks();

    this.currentPage = 1;
    this.swiperElement = null;
    this.swiperWrapperElement = null;
    this.swiper = null;
    this.busy = false;

    const currentPageLinkElement = document.querySelector('.page-link.current');

    if (currentPageLinkElement) {
      this.currentPage = parseInt(currentPageLinkElement.textContent, 10);
    }

    if (this.itemContainer) {
      this.postType = this.itemContainer.dataset.paginationPostType;
      this.exclude = this.itemContainer.dataset.exclude;
      this.tags = this.itemContainer.dataset.tags;
      this.take = this.itemContainer.dataset.take;
      this.categories = this.itemContainer.dataset.categories;
      this.otherCategories = this.itemContainer.dataset.otherCategories;
      this.allSites = this.itemContainer.dataset.allSites;
      this.groupArticlesByMonth = this.itemContainer.dataset.groupArticlesByMonth;

      if (this.itemContainer.dataset.paginationDefaultDisplay) {
        this.itemContainerDefaultDisplay = this.itemContainer.dataset.paginationDefaultDisplay;
      }
    }

    if (this.noResultsContainer && this.noResultsContainer.dataset.paginationDefaultDisplay) {
      // eslint-disable-next-line max-len
      this.noResultsContainerDefaultDisplay = this.noResultsContainer.dataset.paginationDefaultDisplay;
    }

    if (this.pagination && this.pagination.dataset.paginationDefaultDisplay) {
      this.paginationDefaultDisplay = this.pagination.dataset.paginationDefaultDisplay;
    }

    if (this.formElement) {
      this.formElement.addEventListener('submit', (e) => {
        e.preventDefault();

        if (this.applyFiltersButtons && this.applyFiltersButtons.length) {
          this.applyFiltersButtons[0].click();
        }

        return false;
      });
    }
  }

  initPageItemsAndLinks() {
    this.pageItems = document.querySelectorAll('.pagination .page-item');
    this.pageLinks = document.querySelectorAll('.pagination .page-link');
  }

  executeOnTheBrightSide() {
    if (this.pagination) {
      this.changeMarkupForSlider();
      this.turnPagerIntoSlider();
    }

    this.bindEvents();
  }

  changeMarkupForSlider() {
    this.swiperElement = document.createElement('li');
    this.swiperElement.classList.add('swiper');
    this.pagination.appendChild(this.swiperElement);

    this.swiperWrapperElement = document.createElement('ul');
    this.swiperWrapperElement.classList.add('swiper-wrapper');
    this.swiperWrapperElement.classList.add('list-unstyled');
    this.swiperElement.appendChild(this.swiperWrapperElement);

    this.pageItems.forEach((item) => {
      if (item.classList.contains('page-control')) {
        item.classList.remove('disabled');
      }

      if (!item.classList.contains('page-control')) {
        item.classList.add('swiper-slide');
        this.swiperWrapperElement.appendChild(item);
      }
    });
  }

  turnPagerIntoSlider() {
    const self = this;

    this.swiper = new Swiper(this.swiperElement, {
      navigation: {
        prevEl: '.page-control-prev',
        nextEl: '.page-control-next',
        enabled: true,
      },
      slidesPerView: 5,
      slidesPerGroup: 5,
      centerInsufficientSlides: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      spaceBetween: 8,
      breakpoints: {
        480: {
          slidesPerView: 7,
          slidesPerGroup: 7,
        },
        640: {
          spaceBetween: 3,
          slidesPerView: 10,
          slidesPerGroup: 10,
        },
      },
      on: {
        slidesLengthChange() {
          self.pagination.style.display = self.getCurrentNumberOfPages() < 2 ? 'none' : 'flex';
        },
      },
    });
  }

  bindEvents() {
    if (this.applyFiltersButtons) {
      this.bindEventsToApplyFilterButtons();
    }

    if (this.pagination) {
      this.bindEventsToPageLinks();
    }
  }

  bindEventsToApplyFilterButtons() {
    this.applyFiltersButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();

        if (e.currentTarget.classList.contains('active')) {
          e.currentTarget.classList.remove('active');
        } else {
          e.currentTarget.classList.add('active');
        }

        this.changeCurrentPage(1);

        this.updateContent();
      });
    });
  }

  bindEventsToPageLinks() {
    this.pageLinks.forEach((link) => {
      if (link.classList.contains('prev') || link.classList.contains('next')) {
        return;
      }

      this.bindClickEventToPageLink(link);
    });
  }

  bindClickEventToPageLink(link) {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const top = Pagination.getPositionRelativeToDocument(this.itemContainer) - 100;

      this.changeCurrentPage(parseInt(link.textContent, 10));

      this.updateContent();

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    });
  }

  changeCurrentPage(page) {
    this.currentPage = page;

    const currentItem = document.querySelector('.page-item.active');

    if (currentItem) {
      currentItem.classList.remove('active');
      const currentLink = currentItem.querySelector('.page-link.current');

      if (currentLink) {
        currentLink.classList.remove('current');
      }
    }
  }

  updatePageLinks(numberOfPages) {
    if (!this.pagination) {
      return;
    }

    const currentNumberOfPages = this.getCurrentNumberOfPages();

    if (currentNumberOfPages === numberOfPages) {
      return;
    }

    if (currentNumberOfPages > numberOfPages) {
      this.pageLinks.forEach((link) => {
        const elementForPageNumber = parseInt(link.textContent, 10);

        if (elementForPageNumber > numberOfPages) {
          link.parentElement.remove();
        }
      });
    } else {
      const startAt = currentNumberOfPages + 1;

      for (let x = startAt; x <= numberOfPages; x += 1) {
        const pageItem = document.createElement('li');
        pageItem.classList.add('page-item', 'swiper-slide');

        const pageLink = document.createElement('a');
        pageLink.classList.add('page-link');
        pageLink.href = '#';
        pageLink.textContent = x.toString();
        this.bindClickEventToPageLink(pageLink);

        pageItem.appendChild(pageLink);

        this.swiperWrapperElement.appendChild(pageItem);
      }
    }

    this.initPageItemsAndLinks();

    this.swiper.update();
  }

  updateContent() {
    if (this.busy) {
      return;
    }

    this.busy = true;

    const filterValues = this.collectFilterValues();
   
    const parameters = {
      postType: this.postType,
      page: this.currentPage,
      exclude: this.exclude,
      tags: this.tags,
      take: this.take,
      categories: this.categories,
      otherCategories: this.otherCategories,
      allSites: this.allSites,
      groupArticlesByMonth: this.groupArticlesByMonth,
      filterValues,
    };

    this.itemContainer.classList.add('loading');

    if (this.noResultsContainer) {
      this.noResultsContainer.classList.add('loading');
    }

    axios.post('/wp-json/gpgroot/v1/get-content-for-page', parameters).then((response) => {
      if (response && response.data) {
        this.switchView(false);

        this.itemContainer.innerHTML = response.data.itemsMarkup;

        this.updatePageLinks(response.data.numberOfPages);
      } else {
        this.switchView(true);
      }
    }).then(() => {
      this.itemContainer.classList.remove('loading');

      if (this.noResultsContainer) {
        this.noResultsContainer.classList.remove('loading');
      }

      this.makeCurrentPageLinkActive();

      this.busy = false;
    });
  }

  switchView(showNoResults) {
    if (this.noResultsContainer && showNoResults) {
      this.noResultsContainer.style.setProperty('display', this.noResultsContainerDefaultDisplay, 'important');
    } else if (this.noResultsContainer && !showNoResults) {
      this.noResultsContainer.style.setProperty('display', 'none', 'important');
    }

    if (this.itemContainer && showNoResults) {
      this.itemContainer.style.setProperty('display', 'none', 'important');
    } else if (this.itemContainer && !showNoResults) {
      this.itemContainer.style.setProperty('display', this.itemContainerDefaultDisplay, 'important');
    }

    if (this.pagination && showNoResults) {
      this.pagination.style.setProperty('display', 'none', 'important');
    } else if (this.pagination && !showNoResults) {
      this.pagination.style.setProperty('display', this.paginationDefaultDisplay, 'important');
    }
  }

  makeCurrentPageLinkActive() {
    if (!this.pagination) {
      return;
    }

    this.pageLinks.forEach((link) => {
      if (parseInt(link.textContent, 10) === this.currentPage) {
        link.parentElement.classList.add('active');
        link.classList.add('current');
      }
    });
  }

  getCurrentNumberOfPages() {
    const pages = this.pageLinks.length - 2; // prev + next
    return pages;
  }

  collectFilterValues() {
    if (!this.filterElements || !this.filterElements.length) {
      return null;
    }

    const values = {};

    this.filterElements.forEach((element) => {
      if (element.tagName !== 'BUTTON' || element.classList.contains('active')) {
        if (Object.hasOwn(values, element.name)) {
          if (!Array.isArray(values[element.name])) {
            values[element.name] = [values[element.name]];
          }

          values[element.name].push(element.value);
        } else {
          values[element.name] = element.value;
        }
      }
    });

    return values;
  }

  static getPositionRelativeToDocument(element) {
    let traverseElement = element;
    let y = 0;

    while (traverseElement) {
      y += (traverseElement.offsetTop - traverseElement.scrollTop + traverseElement.clientTop);
      traverseElement = traverseElement.offsetParent;
    }

    return y;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  Pagination.init();
});
